import {Component, forwardRef} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { AbstractWorkflowFormComponent } from '../../@core/abstract-workflow-form-component';
import { ChipsInputModel } from '../chips-input.model';
import { MatChipInputEvent } from '@angular/material/chips';
import {COMMA, ENTER} from '@angular/cdk/keycodes';

@Component({
    selector: 'abw-chips-input-form',
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => ChipsInputFormComponent),
        multi: true
      }
    ],
    templateUrl: './chips-input-form.component.html',
    styleUrls: ['./chips-input-form.component.scss']
})
export class ChipsInputFormComponent extends AbstractWorkflowFormComponent<ChipsInputModel, string> {
    visible = true;
    selectable = true;
    removable = true;
    addOnBlur = true;
    readonly separatorKeysCodes: number[] = [ENTER, COMMA];
    fruits: any[] = [
        {name: 'Lemon'},
        {name: 'Lime'},
        {name: 'Apple'},
    ];

    add(event: MatChipInputEvent): void {
        const input = event.input;
        const value = event.value;

        // Add our fruit
        if ((value || '').trim()) {
        this.fruits.push({name: value.trim()});
        }

        // Reset the input value
        if (input) {
        input.value = '';
        }
    }

    remove(fruit: any): void {
        const index = this.fruits.indexOf(fruit);

        if (index >= 0) {
        this.fruits.splice(index, 1);
        }
    }
}